import { Dialog, DialogContent, DialogTitle, Stack } from "@mui/material";
import React from "react";
import { EGInput } from "../../../../MainComponents/Input/EGInput";
import { EGButton } from "../../../../MainComponents/Button/EGButton/EGButton";
import { useTranslation } from "react-i18next";

export const EditDetails = ({
  editingObs,
  editType,
  commentStatus,
  setCommentStatus,
  message,
  setMessage,
  isLoading,
  hdlModifyCurrentText,
  objectToEdit,
  hdlCloseEditObs,
}) => {
  const [t] = useTranslation("report");

  return (
    <Dialog open={editingObs} sx={{ p: 1 }} fullWidth>
      <DialogTitle
        align="center"
        variant="h6"
        fontSize={"1.3rem"}
        fontWeight={600}
      >
        {t(`Care.edit_${editType}`)}
      </DialogTitle>
      <DialogContent>
        {editType === "observation" && (
          <EGInput
            margin="dense"
            type="textarea"
            label={`${t("Care.observation")}:`}
            value={commentStatus}
            onChange={(e) => setCommentStatus(e.target.value)}
            multiline
            rows={3}
          />
        )}

        {editType === "comment" && (
          <EGInput
            margin="dense"
            label={`${t("Care.report_status_details")}:`}
            placeholder={t("Care.enter_details_about_status_change")}
            sx={{ mt: 1 }}
            multiline
            rows={3}
            value={message}
            onChange={(e) => setMessage(e.target.value)}
          />
        )}
        <Stack
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          flexDirection="row"
          spacing={2}
          mt={1}
        >
          {["observation", "comment"].includes(editType) && (
            <EGButton
              label={t("Care.save")}
              loading={isLoading}
              iconName={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
                  ? "mark_check"
                  : "mark_check_bold"
              }
              disabled={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
              }
              type="submit"
              onClick={() => hdlModifyCurrentText(objectToEdit)}
              color={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
                  ? "light"
                  : "success"
              }
              iconColor={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
                  ? ""
                  : "white"
              }
              iconColorHover={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
                  ? ""
                  : "white"
              }
              labelColor={
                (editType === "observation"
                  ? commentStatus
                  : message
                ).trim() === ""
                  ? ""
                  : "white"
              }
            />
          )}

          <EGButton
            loading={isLoading}
            label={t("Care.cancel")}
            iconName="close_icon"
            iconSize={21}
            onClick={hdlCloseEditObs}
          />
        </Stack>
      </DialogContent>
    </Dialog>
  );
};
